import {PopupContainer} from "@FRAMEWORK/ui/desktop/popup";
import {TableContainer} from "@FRAMEWORK/ui/desktop/table";
import {BlueText} from "@FRAMEWORK/ui/desktop/text";
import RequiredText from "@FRAMEWORK/ui/desktop/text/RequiredText";
import {useEffect, useState} from "react";
import {Checkbox, TextInput, Textarea} from "@FRAMEWORK/ui/desktop/input";
import {SelectBox, SelectLabel, SelectOptions} from "@FRAMEWORK/ui/desktop/select";
import {BulletListItem} from "@FRAMEWORK/ui/desktop/list";
import {TextButton} from "@FRAMEWORK/ui/desktop/button";
import * as style from "@COMPONENTS/style/common/mailshare";
import {OverlayState} from "@/hooks/common/useOverlay";
import {validation} from "@yb/utils";
import useCode from "@QUERIES/essential/code/useCode";
import useEventDetail from "@QUERIES/prdt/event/useEventDetail";
import useGoodsDetail from "@QUERIES/prdt/goods/useGoodsDetail";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {useRouter} from "next/router";

interface SendEmailProps extends OverlayState {
	/** 메일 타입
	 * @description detailPackage : P
	 * @description locallist : G
	 */
	dspGubun: "P" | "G";

	/** goodsCd
	 * @description "G 일때 필수"
	 */
	goodsCd?: string;

	/** evCd
	 * @description "P 일떄 필수"
	 */
	evCd?: string;

	/** menu
	 * @description "P,G 일떄 필수"
	 */
	menu?: string;

	/** dspSid
	 * @description "P,G 일떄 필수"
	 */
	dspSid?: string;
}

const MailShare = (props: SendEmailProps) => {
	const query = useRouter().query as {[x: string]: string};

	const {
		dspGubun,
		evCd = query.evCd || "",
		goodsCd = query.goodsCd || "",
		menu = query.menu || "",
		dspSid = query.dspSid || "",
		...overlay
	} = props;
	const [sameSender, setSameSander] = useState(false);
	const [collect, setCollect] = useState("N");
	const [senderDomain, setSenderDomain] = useState("");
	const [showSenderDomain, setShowSenderDomain] = useState(false);

	const [reciverDomain, setReciverDomain] = useState("");
	const [showReciverDomain, setShowReciverDomain] = useState(false);
	const [required, setRequired] = useState({
		sndrName: "",
		sndrEmail: "",
		rcptName: "",
		rcptEmail: "",
		collect: "",
		subject: "",
		message: "",
	});
	const [value, setValue] = useState({
		dspGubun,
		evCd,
		goodsCd,
		menu,
		dspSid,
		rcptEmail: "",
		rcptName: "",
		sndrEmail: "",
		sndrName: "",
		subject: "",
		message: "",
		collectInfoYn: "N",
	});

	/** 이메일 도메인 공통코드 */
	const code = useCode("WEB_CUST_MAIL", {placeholderData: {body: []}}).data.body;

	const evNm = useEventDetail(evCd, {enabled: dspGubun === "P"}).data.body.evNm;

	const goodsNm = useGoodsDetail(goodsCd, {enabled: dspGubun === "G"}).data.body.goodsNm;

	const input = (key: string) => e => {
		const text = e.target.value.substring(0, key === "subject" ? 60 : 250);
		if (["sndrEmailId", "sndrEmailDomain"].indexOf(key) > -1) {
			const [id, domain = ""] = value.sndrEmail.split("@");
			key === "sndrEmailId" && setValue({...value, sndrEmail: `${text}@${domain}`});
			key === "sndrEmailDomain" && setValue({...value, sndrEmail: `${id}@${text}`});
			setRequired({...required, sndrEmail: ""});
		} else if (["reciverEmailId", "reciverEmailDomain"].indexOf(key) > -1) {
			const [id, domain = ""] = value.rcptEmail.split("@");
			key === "reciverEmailId" && setValue({...value, rcptEmail: `${text}@${domain}`});
			key === "reciverEmailDomain" && setValue({...value, rcptEmail: `${id}@${text}`});
			setRequired({...required, rcptEmail: ""});
		} else {
			setValue({...value, [key]: text});
			setRequired({...required, [key]: ""});
		}
	};
	const onSameSenderChecked = e => setSameSander(!sameSender);
	const onCollectChecked = e => {
		setCollect(e.target.checked === true ? "Y" : "N");
		setValue({...value, collectInfoYn: e.target.checked === true ? "Y" : "N"});
		setRequired({...required, collect: ""});
	};

	const changeSenderDomain = (domainName: string) => () => {
		const [id] = value.sndrEmail.split("@");
		setValue({...value, sndrEmail: `${id}@${domainName.toLowerCase()}`});
		setSenderDomain(domainName);
		setRequired({...required, sndrEmail: ""});
		setShowSenderDomain(false);
	};
	const changeReciverDomain = (domainName: string) => () => {
		const [id] = value.rcptEmail.split("@");
		setValue({...value, rcptEmail: `${id}@${domainName.toLowerCase()}`});
		setReciverDomain(domainName);
		setRequired({...required, rcptEmail: ""});
		setShowReciverDomain(false);
	};

	const formValidation = () => {
		const {sndrName, sndrEmail, rcptName, rcptEmail, subject, message} = value;
		const [sndrId, sndrDomain] = sndrEmail.split("@");
		const [rcptId, rcptDomain] = rcptEmail.split("@");
		/** 보내는 사람  */
		if (sndrName.length === 0) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "이름을 입력하세요."});
			return false;
		}
		if (/\s/g.test(sndrName)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (sndrId.length === 0) {
			(document.querySelector("#sndrEmailId") as HTMLInputElement).focus();
			setRequired({...required, sndrEmail: "보내는 사람의 이메일 주소를 입력하세요."});
			return false;
		}
		if (/\s/g.test(sndrId)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (sndrDomain.length === 0) {
			(document.querySelector("#sndrEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, sndrEmail: "보내는 사람의 이메일 도메인을 입력하세요."});
			return false;
		}
		if (!validation.domain(sndrDomain)) {
			(document.querySelector("#sndrEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, sndrEmail: "보내는 사람의 이메일 도메인을 확인하세요."});
			return false;
		}

		/** 받는 사람 */
		if (rcptName.length === 0) {
			(document.querySelector("#rcptName") as HTMLInputElement).focus();
			setRequired({...required, rcptName: "이름을 입력하세요."});
			return false;
		}
		if (/\s/g.test(rcptName)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (rcptId.length === 0) {
			(document.querySelector("#reciverEmailId") as HTMLInputElement).focus();
			setRequired({...required, rcptEmail: "받는 사람의 이메일 주소를 입력하세요."});
			return false;
		}
		if (/\s/g.test(rcptId)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (rcptDomain.length === 0) {
			(document.querySelector("#reciverEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, rcptEmail: "받는 사람의 이메일 도메인을 입력하세요."});
			return false;
		}
		if (!validation.domain(rcptDomain)) {
			(document.querySelector("#reciverEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, rcptEmail: "받는 사람의 이메일 도메인을 확인하세요."});
			return false;
		}

		/** 내용 */
		if (subject.length === 0) {
			(document.querySelector("#subject") as HTMLInputElement).focus();
			setRequired({...required, subject: "제목을 입력하세요."});
			return false;
		}
		if (message.length === 0) {
			(document.querySelector("#message") as HTMLInputElement).focus();
			setRequired({...required, message: "내용을 입력하세요."});
			return false;
		}

		/** 개인수집 이용 동의 */
		if (value.collectInfoYn === "N") {
			(document.querySelector("#check-agree") as HTMLInputElement).focus();
			setRequired({...required, collect: "개인정보 수집/이용에 동의하셔야합니다."});
			return false;
		}
		return true;
	};

	const sendEmail = async () => {
		try {
			if (formValidation()) {
				const result = await useConfigureAxios({
					method: "POST",
					url: `${publicRuntimeConfig.ENV_ESSENTIAL_API_BASEPATH}/api/mail/share`,
					data: {...value, subject: value.subject.trim(), message: value.message.trim()},
				});
				result.data.code === "0000" &&
					MessageUtil.alert("메일을 발송하였습니다.", () => {
						overlay.close();
					});
				if (result.data.code !== "0000") {
					throw new Error("");
				}
			}
		} catch (e) {
			MessageUtil.alert("메일을 발송에 실패하였습니다.");
		}
	};

	/** 보내는사람과 동일 */
	useEffect(() => {
		const {sndrName, sndrEmail} = value;
		const [id, domain] = sndrEmail.split("@");
		if (sameSender) {
			if (sndrName.length === 0) {
				setRequired({...required, sndrName: "이름을 입력하세요."});
				setSameSander(false);
				return;
			} else if (!id || !domain) {
				setRequired({...required, sndrEmail: "보내는 사람의 이메일 주소를 입력하세요."});
				setSameSander(false);
				return;
			} else if (!validation.domain(domain)) {
				setRequired({...required, sndrEmail: "이메일 도메인 형식이 잘못되었습니다."});
				setSameSander(false);
				return;
			}
			setValue({...value, rcptName: value.sndrName, rcptEmail: value.sndrEmail});
			setRequired({...required, sndrName: "", sndrEmail: ""});
			setReciverDomain(senderDomain);
		} else {
			setValue({...value, rcptName: "", rcptEmail: ""});
			setReciverDomain("");
		}
	}, [sameSender]);

	useEffect(() => {
		if (dspGubun === "P") setValue({...value, subject: evNm});
		if (dspGubun === "G") setValue({...value, subject: goodsNm});
	}, [evNm, goodsNm]);

	useEffect(() => {
		const event = e => {
			if (e.target.closest("#senderDomainSelect") || e.target.closest("#reciverDomainSelect")) return;
			setShowSenderDomain(false);
			setShowReciverDomain(false);
		};
		document.addEventListener("click", event);
		return () => document.removeEventListener("click", event);
	}, []);

	return (
		<PopupContainer {...overlay} title="이메일 공유" size="large">
			<style.TextWrap>
				<style.SubTitle>고객님이 보셨던 상품을 이메일로 공유하실 수 있습니다.</style.SubTitle>
				<style.InfoText>
					<style.RequiredIcon title="필수입력 아이콘" />는 필수입력 항목입니다.
				</style.InfoText>
			</style.TextWrap>
			<TableContainer>
				<caption>이메일 공유 정보 폼</caption>
				<colgroup>
					<col style={{width: "153px"}} />
					<col style={{width: "757px"}} />
				</colgroup>
				<tbody>
					<tr>
						<th scope="row">상품명</th>
						<td>
							<style.ProductName>
								{dspGubun === "P" && evNm}
								{dspGubun === "G" && goodsNm}
							</style.ProductName>
						</td>
					</tr>
					<tr>
						<th scope="row">
							<style.RequiredCheck title="필수입력" />
							보내는 사람
						</th>
						<td>
							<style.TblLine>
								<style.InputRow padding={true} wrong={!!required.sndrName}>
									<style.InputLabel>이름</style.InputLabel>
									<input
										id="sndrName"
										type="text"
										placeholder="이름을 입력하세요."
										onChange={input("sndrName")}
										value={value.sndrName}
									/>
									{required.sndrName && <RequiredText>{required.sndrName}</RequiredText>}
								</style.InputRow>
								<style.InputRow wrong={!!required.sndrEmail}>
									<style.InputLabel>이메일</style.InputLabel>
									<input
										id="sndrEmailId"
										type="text"
										placeholder="이메일 아이디"
										onChange={input("sndrEmailId")}
										value={value.sndrEmail.split("@").at(0)}
									/>
									<span>@</span>
									<input
										id="sndrEmailDomain"
										type="text"
										readOnly={!!senderDomain}
										placeholder="이메일 도메인"
										onChange={input("sndrEmailDomain")}
										value={value.sndrEmail.split("@")?.at(1) || ""}
									/>
									<style.SelectWrap id="senderDomainSelect">
										<SelectBox onClick={() => setShowSenderDomain(!showSenderDomain)}>
											<SelectLabel>{senderDomain.toLocaleLowerCase() || "직접입력"}</SelectLabel>
										</SelectBox>
										{showSenderDomain && (
											<SelectOptions>
												<li onClick={changeSenderDomain("")}>직접입력</li>
												{code.map(item => (
													<li key={item.commCdId} onClick={changeSenderDomain(item.commCdId)}>
														{item.commCdNm}
													</li>
												))}
											</SelectOptions>
										)}
									</style.SelectWrap>
									{required.sndrEmail && <RequiredText>{required.sndrEmail}</RequiredText>}
								</style.InputRow>
							</style.TblLine>
						</td>
					</tr>
					<tr>
						<th scope="row">
							<style.RequiredCheck title="필수입력" />
							받는 사람
						</th>
						<td>
							<style.TblLine>
								<style.InputRow padding={true} wrong={!!required.rcptName}>
									<style.InputLabel>이름</style.InputLabel>
									<input
										type="text"
										id="rcptName"
										onChange={input("rcptName")}
										value={value.rcptName}
										placeholder="이름을 입력하세요."
									/>
									{required.rcptName && <RequiredText>{required.rcptName}</RequiredText>}
								</style.InputRow>
								<style.InputRow wrong={!!required.rcptEmail}>
									<style.InputLabel>이메일</style.InputLabel>
									<input
										type="text"
										placeholder="이메일 아이디"
										onChange={input("reciverEmailId")}
										value={value.rcptEmail.split("@").at(0)}
										id="reciverEmailId"
									/>
									<span>@</span>
									<input
										type="text"
										placeholder="이메일 도메인"
										readOnly={!!reciverDomain}
										onChange={input("reciverEmailDomain")}
										value={value.rcptEmail.split("@")?.at(1) || ""}
										id="reciverEmailDomain"
									/>
									<style.SelectWrap id="reciverDomainSelect">
										<SelectBox onClick={() => setShowReciverDomain(!showReciverDomain)}>
											<SelectLabel>{reciverDomain.toLocaleLowerCase() || "직접입력"}</SelectLabel>
										</SelectBox>
										{showReciverDomain && (
											<SelectOptions>
												<li onClick={changeReciverDomain("")}>직접입력</li>
												{code.map(item => (
													<li key={item.commCdId} onClick={changeReciverDomain(item.commCdId)}>
														{item.commCdNm}
													</li>
												))}
											</SelectOptions>
										)}
									</style.SelectWrap>
									<style.CheckWrap>
										<Checkbox id="check-all" value="same" onChange={onSameSenderChecked} checked={sameSender} />
										<label htmlFor="check-all">보내는 사람과 동일</label>
									</style.CheckWrap>
									{required.rcptEmail && <RequiredText>{required.rcptEmail}</RequiredText>}
								</style.InputRow>
							</style.TblLine>
						</td>
					</tr>
					<tr>
						<th scope="row">
							<style.RequiredCheck title="필수입력" />
							제목
							<br />(<BlueText>{value.subject.length}</BlueText>자 / 60자)
						</th>
						<td>
							<style.InputRow wrong={!!required.subject}>
								<TextInput type="text" id="subject" onChange={input("subject")} value={value.subject} />
								{required.subject && <RequiredText>{required.subject}</RequiredText>}
							</style.InputRow>
						</td>
					</tr>
					<tr>
						<th scope="row">
							<style.RequiredCheck title="필수입력" />
							내용
							<br />(<BlueText>{value.message.length}</BlueText>자 / 250자)
						</th>
						<td>
							<style.InputRow wrong={!!required.message}>
								<Textarea
									id="message"
									height="200px"
									onChange={input("message")}
									value={value.message}
									placeholder="250자 이내로 작성하실 수 있습니다."
								/>
								{required.message && <RequiredText>{required.message}</RequiredText>}
							</style.InputRow>
						</td>
					</tr>
				</tbody>
			</TableContainer>
			<style.BulletList>
				<BulletListItem>
					메일 발송 서비스 제공을 위해 아래와 같이 개인정보를 수집할 수 있습니다.
					<br />
					단순 메일 보내기 기능으로써 기재 정보는 별도 보관되어지지 않습니다.
				</BulletListItem>
			</style.BulletList>
			<style.AgreeBox>
				<style.AgreeText>
					<style.AgreeList>
						<style.AgreeListItem>수집항목 : 보내는 사람, 받는 사람의 이름 및 이메일 주소</style.AgreeListItem>
						<style.AgreeListItem>수집목적 : 이용자의 상품 공유 메일 발송을 위함</style.AgreeListItem>
						<style.AgreeListItem>보유기간 : 보유하지 않음</style.AgreeListItem>
					</style.AgreeList>
				</style.AgreeText>
				<style.AgreeCheck>
					<style.InputRow wrong={true}>
						<style.AgreeCheckWrap>
							<Checkbox
								id="check-agree"
								onChange={onCollectChecked}
								value="이메일 발송 서비스 동의"
								checked={collect === "Y"}
							/>
							<label htmlFor="check-agree">이메일 발송 서비스를 위한 개인정보 수집 이용에 동의합니다.</label>
						</style.AgreeCheckWrap>
						{required.collect && <RequiredText>{required.collect}</RequiredText>}
					</style.InputRow>
				</style.AgreeCheck>
			</style.AgreeBox>
			<style.BtnArea>
				<TextButton text="발송하기" types="confirm" width="basic" onClick={sendEmail} />
				<TextButton text="취소" types="basic" width="basic" onClick={overlay.close} />
			</style.BtnArea>
		</PopupContainer>
	);
};

export default MailShare;
